export default "__VITE_ASSET__fa870497__"